export default __webpack_public_path__ + "static/patient-education-tablet-a17093ab626c9ed5f5d98ae8fd8547bb.png";